import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   Livevalues
export const Livevalues = createSlice({
  name: "Livevalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Livevalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_Livevalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Livevalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Livevalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Livevalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchLivevalues:(state)=>{
        state.switch = false
    }
  },
});
export default Livevalues.reducer;
export const {
  Livevalues_datagrid,
  success_api_call_Livevalues_datagrid,
  failure_api_call_Livevalues_datagrid,
  create_Livevalues_datagrid_complete_api,
  Livevalues_datagrid_is_success,false_switchLivevalues
} = Livevalues.actions;
